import {Component} from 'react';
import {connect} from 'react-redux';
import Auth from '../auth/auth';

const auth = new Auth();

/**
 * A code-level, scope-blind HINT — never a control (docs/access/slice-4b-admin-surface-plan.md
 * §3.6). Answers "does the user hold this permission code ANYWHERE", not "at this scope": a real
 * scope check needs a JS port of accessEvaluator's expandScope + CHAIN_LEVELS, plus
 * object→schema→instance ancestry the UI mostly does not have — a second copy of the evaluator,
 * the drift class 4a's §3.1 refused on the server and worse here, since nothing would catch it.
 *
 * FAILS OPEN IN SHADOW. Hiding a control the incumbent would have honoured is a self-inflicted
 * outage during a phase whose contract is that nothing changes. The server is the only real gate;
 * this only ever removes a button the server would refuse anyway — never the reverse.
 *
 * `enforcement` is `{mode, modules}` (§3.4), not a boolean: the flip is staged per module, so a
 * global "is it enforced" answer would report shadow while the caller's own module is live.
 *
 * `module`, when given, must be the exact router mount prefix (e.g. `/dataDictionary`) — the same
 * string `AC_ENFORCE`/`req.baseUrl` use server-side, already lowercased on the wire. A translated
 * or shortened name here would be a second copy of route-to-module knowledge that can drift from
 * `server/app.js`'s actual mounts, which is the exact trap `authorize.js`'s own comment is about.
 */
export class Can extends Component {
  isModuleEnforced() {
    const {module, enforcement} = this.props;
    if (!enforcement || enforcement.mode === 'none') return false;
    if (enforcement.mode === 'all') return true;
    // mode === 'modules': ambiguous with no module named, and over-showing is the safe
    // direction (§3.4) — a button the server will refuse beats hiding one it would allow.
    if (!module) return false;
    return (enforcement.modules || []).includes(String(module).toLowerCase());
  }

  render() {
    const {code, children} = this.props;
    if (!this.isModuleEnforced()) return children || null;
    return this.props.permissions.includes(code) ? (children || null) : null;
  }
}

const mapStateToProps = () => ({
  permissions: auth.getAcPermissions(),
  enforcement: auth.getAcEnforcement(),
});

export default connect(mapStateToProps)(Can);
